/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The actions for the widget Search Accounts
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { createAction } from '../../../../../modules/app/createAction';
import {
    IWidgetSearchAccountsLoadListFailedPayload,
    IWidgetSearchAccountsLoadListPayload,
    IWidgetSearchAccountsLoadListSuccessfulPayload,
    IWidgetSearchAccountsSetAccountPayload,
    IWidgetSearchAccountsSetSearchValuePayload,
    TWidgetSearchAccountsInitAction,
    TWidgetSearchAccountsLoadListAction,
    TWidgetSearchAccountsLoadListFailedAction,
    TWidgetSearchAccountsLoadListSuccessfulAction,
    TWidgetSearchAccountsSetAccountAction,
    TWidgetSearchAccountsSetSearchValueAction,
} from './types/widgetSearchAccountsActionTypes';
import {
    WIDGET_SEARCH_ACCOUNTS_INIT,
    WIDGET_SEARCH_ACCOUNTS_LOAD_LIST,
    WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_FAILED,
    WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_SUCCESSFUL,
    WIDGET_SEARCH_ACCOUNTS_SET_ACCOUNT,
    WIDGET_SEARCH_ACCOUNTS_SET_SEARCH_VALUE,
} from './widgetSearchAccountsConstants';

/*
* -------------------------------------------
*           WIDGET INIT
* -------------------------------------------
*/

export const widgetSearchAccountsInit = (): TWidgetSearchAccountsInitAction =>
        createAction(WIDGET_SEARCH_ACCOUNTS_INIT);

/*
* -------------------------------------------
*           LOAD ACCOUNT LIST
* -------------------------------------------
*/

export const widgetSearchAccountsLoadList =
    (payload?: IWidgetSearchAccountsLoadListPayload): TWidgetSearchAccountsLoadListAction =>
        createAction(WIDGET_SEARCH_ACCOUNTS_LOAD_LIST, payload);

export const widgetSearchAccountsLoadListSuccessful =
    (payload: IWidgetSearchAccountsLoadListSuccessfulPayload): TWidgetSearchAccountsLoadListSuccessfulAction =>
        createAction(WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_SUCCESSFUL, payload);

export const widgetSearchAccountsLoadListFailed =
    (payload: IWidgetSearchAccountsLoadListFailedPayload): TWidgetSearchAccountsLoadListFailedAction =>
        createAction(WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_FAILED, payload);

/*
* -------------------------------------------
*           SET ACCOUNT
* -------------------------------------------
*/

export const widgetSearchAccountsSetAccount =
    (payload: IWidgetSearchAccountsSetAccountPayload): TWidgetSearchAccountsSetAccountAction =>
    createAction(WIDGET_SEARCH_ACCOUNTS_SET_ACCOUNT, payload);

/*
* -------------------------------------------
*           SET SEARCH VALUE
* -------------------------------------------
*/

export const widgetSearchAccountsSetSearchValue =
    (payload: IWidgetSearchAccountsSetSearchValuePayload): TWidgetSearchAccountsSetSearchValueAction =>
        createAction(WIDGET_SEARCH_ACCOUNTS_SET_SEARCH_VALUE, payload);
